<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">{{ texts.statements.title }}</div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            {{ texts.statements.subtitle }}
          </div>
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-4">
        <v-col class="pa-0">
          <div style="width: 200px;">
            <v-select
              outlined
              hide-details
              style="border-radius: 15px;"
              v-model="currentYear"
              :items="years"
              :hint="this.selectLanguage == 'en' ? 'Select year' : 'Selecciona año'"
              @change="getStatements()"
            ></v-select>
          </div>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header hide-default-footer :items-per-page="12" :items="items">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr> 
              <th class="header__title left">{{ texts.statements.month }}</th>
              <th class="header__title right">{{ texts.suppliers.actions }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.name }}</td>
              <td class="table__item">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <v-btn :disabled="!item.available" @click="downloadStatement(item)" color="#0075B8" outlined elevation="3" style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;">
                    <v-img class="mr-2" :src="item.available ? require('../../assets/icons/Vector1.svg') : require('../../assets/icons/Vector2.svg')" style="width: 14px;"></v-img>
                    {{ texts.suppliers.download }}
                  </v-btn>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr class="table__item" style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ texts.statements.month }}</div>
                <div>{{ item.name }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ texts.suppliers.actions }}</div>
                <div>
                  <div style="display: flex; align-items: center; justify-content: center;">
                    <v-btn :disabled="!item.available" @click="downloadStatement(item)" color="#0075B8" outlined elevation="3" style="color: #0075BB; border-radius: 36px; border: 2px solid #0075BB; background-color: #fff; font-family: 'montserrat-semibold'; text-transform: none;">
                      <v-img class="mr-2" :src="item.available ? require('../../assets/icons/Vector1.svg') : require('../../assets/icons/Vector2.svg')" style="width: 14px;"></v-img>
                      {{ texts.suppliers.download }}
                    </v-btn>
                  </div>
                </div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "DashboardView",
  data() {
    return {
      texts: "",
      drawer: null,
      actualCurrency: "0",
      actualCurrencyMxn: "0",
      referenceCurrency: "0",
      isLoading: false,
      isRegisterEfex: true,
      exchangeRateData: [],
      selected: [],
      exchangeRateDataPaid: [],
      exchangeRateDataSeparate: [],
      balanceMxn: "0",
      balanceUsd: "0",
      balance: "0",
      items: [],
      tab: 0,
      contacts: [],
      itemsSelected: [],
      itemsSelectedForwards: [],
      isForwardRateCalculated: false,
      bSelectedAll: false,
      dialogAddFoundss: false,
      dialogSendPay: false,
      dialogAddFounds: false,
      dataAddFounds: {},
      dialogCreate: false,
      dialogPay: false,
      editableData: {},
      selectedCard: null,
      totalUsd: 0,
      selectedMenuItem: "dashboard",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      },
      isForwardsActive: false,
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      bLoading: false,
      isDeferredPayment: false,
      stepper: false,
      e1: 1,
      timerCount: 30,
      headersForex: [
        { text: "Month", value: "name", align: "center" },
        { text: "Actions", value: "actions", align: "center" },
      ],
      timerId: null,
      dataEfex: {},
      exchangeRateAdjustments: [],
      exchangeRatesStateForwards: [],
      isPayMxn: false,
      bSelectedAllSeparate: false,
      dialogEditProfileActive: false,
      isForwards: false,
      isForwardsPayment: false,
      userName: "",
      modalCurrency: 0,
      miniVariant: true,
      expandOnHover: false,
      transactions: [],
      invoices: [],
      years: ["2024", "2025", "2026", "2027"],
      currentYear: "2024",
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    tabStyle(tabIndex) {
      return {
        color: this.tab === tabIndex ? "#f0be43" : "#506172",
        fontSize: "16px",
        fontWeight: "600",
        width: "200px",
        lineHeight: "24px",
        fontFamily: "montserrat-bold"
      };
    },
    handleResize: function () {
      if (window.innerWidth >= 960) {
        this.screenWidth = 30;
      } else {
        this.screenWidth = 100;
      }

      this.isResponsive = window.innerWidth < 960;
    },
    getStatements() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/${this.selectLanguage}/statements/statements`, {
          params: { year: this.currentYear },
          headers: {
          Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : "",
          },
      }).then((response) => {
          this.isLoading = false;
          this.items = response.data.monthsAvailable;
      });
    },
    downloadStatement(item) {
      this.loading = true;
      const payload = {
        month: item.month,
        year: this.currentYear
      };

      DB.post(
        `${URI}/api/v1/${this.selectLanguage}/statements/statements`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: "arraybuffer", // Recibir los datos como binarios
        }
      )
      .then((response) => {
        try {
          const blob = new Blob([response.data], { type: "application/pdf" });

          const url = URL.createObjectURL(blob);

          window.open(url, "_blank");

          setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (e) {

        } finally {
          this.loading = false; // Detener el indicador de carga
        }
      })
      .catch((error) => {
        this.mixError(error.response.data.message, error.response.status);
      });
    },
  },
  beforeMount() {
    this.texts = FILE.takeRate[this.selectLanguage];
    this.getStatements();
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
    formattedTime() {
      const minutes = Math.floor(this.timerCount / 60);
      const seconds = this.timerCount % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    }
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.takeRate[this.selectLanguage];
        this.getStatements();
      }
    },
    "editableData.sProvider": function (newValue) {
      this.showCreateProvider = newValue === 0;
    }
  }
};
</script>

<style scoped>
.buttonAddFounds {
    text-align: center;
    color: #0075B8;
    font-size: 16px;
    font-family: "montserrat-semibold";
    font-weight: 600;
    line-height: 24px;
    text-transform: capitalize;
    word-wrap: break-word;
}

.bg-container {
  width: 100%;
  background: #fff;
  opacity: 1;
  height: 100%;
}
.full-height {
  height: 100vh;
  width: 100%;
  overflow-y: auto;
}
.active {
  background-color: #f0f0f0;
}
/* .active-section .v-list-item__icon {
  color: yellow !important;
  background-color: yellow !important;
}

.active-section .v-list-item__title {
  background-color: yellow !important;
} */

.active-item {
  background-color: #f5f7f9 !important;
}
.button-add {
  background: transparent linear-gradient(258deg, #ffc556 0%, #fffc81 100%) 0%
    0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  text-align: center;
  font-size: 14px;
  letter-spacing: 0px;
  color: #283c4d;
  text-transform: initial;
}
.v-tabs-slider {
  background: #f0be43 !important;
  height: 3px;
  color: #f0be43 !important;
  border-radius: 100px;
}

.card-main {
  width: 40vh;
  height: 16vh;
  position: relative;
  background: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
}

.card-content {
  position: absolute;
  top: 19px;
  left: 16px;
}

.circle-content {
  text-align: center;
  color: white;
  margin: auto;
}

.btn-custom {
  color: #f0be43;
}

.card-title {
  color: #302e2e;
  font-size: 16px;
  font-family: montserrat-bold;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 8px;
}

.card-info,
.balance-title {
  color: #777777;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
}

.card-mxn {
  width: 200px;
  color: #f0be43;
  font-size: 24px;
  font-family: Mons;
  font-weight: 700;
  line-height: 36px;
  font-style: normal;
  word-wrap: break-word;
}

.container-width,
.header-container {
  max-width: 1280px;
  margin: auto;
}

.title-medium {
  font-family: "montserrat-semibold";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.headline-medium {
  font-family: "montserrat-semibold";
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.body-large {
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}

.blocked-amount {
  font-family: "montserrat-regular";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.blocked-amount-2 {
  color: #302e2e;
  font-family: "montserrat-regular";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
}

.circle-sheet {
  width: 200px;
  height: 200px;
  padding-left: 17px;
  padding-right: 62px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
  position: absolute;
  right: -60px;
  top: -20px;
}

.usd-balance {
  color: #666565;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.content-balance {
  color: #302e2e;
  font-family: "montserrat-medium", sans-serif;
  font-size: 22px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  padding-top: 10px;
}

.h5 {
  font-family: "montserrat-bold";
  font-size: 24px;
  line-height: 36px;
  text-align: left;
}

.buttonAddFounds {
  text-align: center;
  color: #f0be43;
  font-size: 16px;
  font-family: "montserrat-semibold";
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;
  word-wrap: break-word;
}

.modalTextAddFounds {
  color: #302e2e;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.table th {
  background-color: #f2f2f4;
  /* border: 1px solid #ccc; */
}

@media (max-width: 1150px) {
  .card-title {
    font-size: 14px;
  }

  .card-mxn {
    font-size: 20px;
  }

  .usd-balance {
    font-size: 12px;
  }

  .content-balance {
    font-size: 18px;
  }

  .blocked-amount {
    font-size: 12px;
  }

  .blocked-amount-2 {
    font-size: 14px;
  }

  .buttonAddFounds {
    font-size: 14px;
  }

  .circle-sheet {
    display: none;
  }
}

@media (max-width: 1250px) {
  .circle-sheet {
    width: 155px;
    height: 170px;
    padding-left: 17px;
    padding-right: 40px;
    right: -50px;
    top: -5px;
  }
}

</style>
